import { render, staticRenderFns } from "./MealsFilterList.vue?vue&type=template&id=71ea829a&scoped=true&"
import script from "./MealsFilterList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MealsFilterList.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./MealsFilterList.vue?vue&type=style&index=0&id=71ea829a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ea829a",
  null
  
)

export default component.exports